import axios from 'axios';

export const sendMail = (user) => axios.post('/api/mail', {user});
